module.exports = __webpack_public_path__ + "img/onboarding-banner.c7d44d51.png";